import { ReactElement } from 'react'
import { Stars, Text } from '../..'
import { StarsWithTotalProps } from './props'
import { StyledStarsWithTotal } from './styles'

const StarsWithTotal = ({
    numberOfReviews,
    rating,
    size,
    ...props
}: StarsWithTotalProps): ReactElement => (
    <StyledStarsWithTotal {...props}>
        <Stars rating={rating} size={size} />
        <Text size={size}>({numberOfReviews})</Text>
    </StyledStarsWithTotal>
)

export default StarsWithTotal

export { StyledStarsWithTotal }
